export default __webpack_public_path__ + "static/media/OtherRequests.969b1847.png";